{
  "version": 1,
  "member": {
    "label": {
      "en": "Member",
      "ro": "Membru",
      "es": "Miembro",
      "fr": "Membre",
      "de": "Mitglied",
      "it": "Membro"
    },
    "signup": {
      "displayNameLabel": {
        "en": "Your profile name",
        "ro": "Numele tau de profil",
        "es": "Nombre de perfil",
        "fr": "Nom de profil",
        "de": "Profilname",
        "it": "Nome profilo"
      },
      "displayNamePlaceholder": {
        "en": "Sam",
        "ro": "Sam",
        "es": "Sam",
        "fr": "Sam",
        "de": "Sam",
        "it": "Sam"
      },
      "fields": []
    },
    "profile": {
      "sections": [
        {
          "id": "dating-profile",
          "label": {
            "en": "Dating profile",
            "ro": "Profil dating",
            "es": "Perfil de citas",
            "fr": "Profil rencontre",
            "de": "Dating-Profil",
            "it": "Profilo dating"
          },
          "fields": [
            {
              "id": "account-kind",
              "name": "accountKind",
              "label": {
                "en": "Profile type",
                "ro": "Tip profil",
                "es": "Tipo de perfil",
                "fr": "Type de profil",
                "de": "Profiltyp",
                "it": "Tipo profilo"
              },
              "kind": "text"
            },
            {
              "id": "looking-for",
              "name": "lookingFor",
              "label": {
                "en": "Looking for",
                "ro": "Ce cauta",
                "es": "Busca",
                "fr": "Recherche",
                "de": "Gesucht",
                "it": "Cerca"
              },
              "kind": "multiselect"
            }
          ]
        },
        {
          "id": "dating-identity",
          "label": {
            "en": "Dating preferences",
            "ro": "Preferințe de dating",
            "es": "Preferencias de citas",
            "fr": "Préférences de rencontre",
            "de": "Dating-Präferenzen",
            "it": "Preferenze di incontri"
          },
          "fields": [
            {
              "id": "gender",
              "name": "gender",
              "label": {
                "en": "Your gender",
                "ro": "Genul tau",
                "es": "Tu genero",
                "fr": "Votre genre",
                "de": "Dein Geschlecht",
                "it": "Il tuo genere"
              },
              "kind": "select",
              "required": false,
              "placeholder": {
                "en": "Select an option",
                "ro": "Alege o optiune",
                "es": "Elige una opcion",
                "fr": "Choisir une option",
                "de": "Option wahlen",
                "it": "Scegli un'opzione"
              },
              "options": [
                {
                  "value": "woman",
                  "label": {
                    "en": "Woman",
                    "ro": "Femeie",
                    "es": "Mujer",
                    "fr": "Femme",
                    "de": "Frau",
                    "it": "Donna"
                  }
                },
                {
                  "value": "man",
                  "label": {
                    "en": "Man",
                    "ro": "Barbat",
                    "es": "Hombre",
                    "fr": "Homme",
                    "de": "Mann",
                    "it": "Uomo"
                  }
                },
                {
                  "value": "non_binary",
                  "label": {
                    "en": "Non-binary",
                    "ro": "Non-binar",
                    "es": "No binario",
                    "fr": "Non-binaire",
                    "de": "Nichtbinar",
                    "it": "Non binario"
                  }
                },
                {
                  "value": "trans_woman",
                  "label": {
                    "en": "Trans woman",
                    "ro": "Femeie trans",
                    "es": "Mujer trans",
                    "fr": "Femme trans",
                    "de": "Trans Frau",
                    "it": "Donna trans"
                  }
                },
                {
                  "value": "trans_man",
                  "label": {
                    "en": "Trans man",
                    "ro": "Barbat trans",
                    "es": "Hombre trans",
                    "fr": "Homme trans",
                    "de": "Trans Mann",
                    "it": "Uomo trans"
                  }
                },
                {
                  "value": "self_describe",
                  "label": {
                    "en": "Self-describe later",
                    "ro": "Descriu mai tarziu",
                    "es": "Describir despues",
                    "fr": "Decrire plus tard",
                    "de": "Spater selbst beschreiben",
                    "it": "Descrivere dopo"
                  }
                }
              ]
            },
            {
              "id": "sexuality",
              "name": "sexuality",
              "label": {
                "en": "Your orientation",
                "ro": "Orientarea ta",
                "es": "Tu orientacion",
                "fr": "Votre orientation",
                "de": "Deine Orientierung",
                "it": "Il tuo orientamento"
              },
              "kind": "select",
              "placeholder": {
                "en": "Select an option",
                "ro": "Alege o optiune",
                "es": "Elige una opcion",
                "fr": "Choisir une option",
                "de": "Option wahlen",
                "it": "Scegli un'opzione"
              },
              "options": [
                {
                  "value": "bisexual",
                  "label": {
                    "en": "Bisexual",
                    "ro": "Bisexual",
                    "es": "Bisexual",
                    "fr": "Bisexuel",
                    "de": "Bisexuell",
                    "it": "Bisessuale"
                  }
                },
                {
                  "value": "pansexual",
                  "label": {
                    "en": "Pansexual",
                    "ro": "Pansexual",
                    "es": "Pansexual",
                    "fr": "Pansexuel",
                    "de": "Pansexuell",
                    "it": "Pansessuale"
                  }
                },
                {
                  "value": "queer",
                  "label": {
                    "en": "Queer",
                    "ro": "Queer",
                    "es": "Queer",
                    "fr": "Queer",
                    "de": "Queer",
                    "it": "Queer"
                  }
                },
                {
                  "value": "straight",
                  "label": {
                    "en": "Straight",
                    "ro": "Heterosexual",
                    "es": "Heterosexual",
                    "fr": "Heterosexuel",
                    "de": "Heterosexuell",
                    "it": "Eterosessuale"
                  }
                },
                {
                  "value": "gay",
                  "label": {
                    "en": "Gay",
                    "ro": "Gay",
                    "es": "Gay",
                    "fr": "Gay",
                    "de": "Gay",
                    "it": "Gay"
                  }
                },
                {
                  "value": "lesbian",
                  "label": {
                    "en": "Lesbian",
                    "ro": "Lesbiana",
                    "es": "Lesbiana",
                    "fr": "Lesbienne",
                    "de": "Lesbisch",
                    "it": "Lesbica"
                  }
                },
                {
                  "value": "questioning",
                  "label": {
                    "en": "Questioning",
                    "ro": "In explorare",
                    "es": "En exploracion",
                    "fr": "En questionnement",
                    "de": "Suchend",
                    "it": "In esplorazione"
                  }
                }
              ],
              "required": false
            }
          ]
        }
      ]
    }
  },
  "relationships": {
    "defaultType": "connection",
    "types": [
      {
        "id": "connection",
        "label": {
          "en": "Relationship",
          "ro": "Relatie",
          "es": "Relacion",
          "fr": "Relation",
          "de": "Beziehung",
          "it": "Relazione"
        },
        "actionLabel": {
          "en": "Connect",
          "ro": "Conecteaza",
          "es": "Conectar",
          "fr": "Connecter",
          "de": "Verbinden",
          "it": "Connetti"
        },
        "successLabel": {
          "en": "Connected",
          "ro": "Conectat",
          "es": "Conectado",
          "fr": "Connecte",
          "de": "Verbunden",
          "it": "Connesso"
        },
        "titleMode": "required",
        "titleLabel": {
          "en": "Relationship title",
          "ro": "Titulatura relatiei",
          "es": "Titulo de la relacion",
          "fr": "Titre de relation",
          "de": "Beziehungstitel",
          "it": "Titolo relazione"
        },
        "defaultTitle": "partner",
        "titleOptions": [
          {
            "value": "wife",
            "label": {
              "en": "Wife",
              "ro": "Sotie",
              "es": "Esposa",
              "fr": "Epouse",
              "de": "Ehefrau",
              "it": "Moglie"
            }
          },
          {
            "value": "husband",
            "label": {
              "en": "Husband",
              "ro": "Sot",
              "es": "Esposo",
              "fr": "Epoux",
              "de": "Ehemann",
              "it": "Marito"
            }
          },
          {
            "value": "spouse",
            "label": {
              "en": "Spouse",
              "ro": "Sot/sotie",
              "es": "Conyuge",
              "fr": "Conjoint",
              "de": "Ehepartner",
              "it": "Coniuge"
            }
          },
          {
            "value": "partner",
            "label": {
              "en": "Partner",
              "ro": "Partener",
              "es": "Pareja",
              "fr": "Partenaire",
              "de": "Partner",
              "it": "Partner"
            }
          },
          {
            "value": "date",
            "label": {
              "en": "Date",
              "ro": "Dating",
              "es": "Cita",
              "fr": "Rendez-vous",
              "de": "Date",
              "it": "Appuntamento"
            }
          },
          {
            "value": "friend",
            "label": {
              "en": "Friend",
              "ro": "Prieten",
              "es": "Amigo",
              "fr": "Ami",
              "de": "Freund",
              "it": "Amico"
            }
          }
        ]
      }
    ]
  }
}
